import type { ItemLite } from "@plannello/shared";
import type { Catalog } from "@/data/catalog";
import { loc } from "@/lib/format";

export type Chip = { id: string; label: string; color?: string; field?: string };

/**
 * The item's Field values (in Field order) followed by its plain labels, as chips. Field values
 * carry the Field name so lists can say "Area: Auth" to screen readers.
 */
export function itemChips(item: ItemLite, catalog: Catalog): Chip[] {
  const fieldChips: Array<Chip & { order: number }> = [];
  const plain: Chip[] = [];
  for (const id of item.labelIds) {
    const l = catalog.labelById.get(id);
    if (!l) continue;
    const g = l.groupId ? catalog.groupById.get(l.groupId) : undefined;
    if (g)
      fieldChips.push({
        id,
        label: loc(l.name),
        color: l.color,
        field: loc(g.name),
        order: g.position * 1000 + l.position,
      });
    else plain.push({ id, label: loc(l.name), color: l.color });
  }
  fieldChips.sort((a, b) => a.order - b.order);
  return [...fieldChips, ...plain];
}

export type ChildStats = { total: number; done: number };

/** Children per parent id with how many are completed or canceled. */
export function childStats(items: Iterable<ItemLite>, catalog: Catalog): Map<string, ChildStats> {
  const out = new Map<string, ChildStats>();
  for (const i of items) {
    if (!i.parentId || i.archivedAt) continue;
    const s = out.get(i.parentId) ?? { total: 0, done: 0 };
    s.total++;
    const cat = catalog.statusById.get(i.statusId)?.category;
    if (cat === "completed" || cat === "canceled") s.done++;
    out.set(i.parentId, s);
  }
  return out;
}
